import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { forkJoin } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LottoService extends BaseService {

  constructor(injector: Injector) {
    super(injector);
  }

  get(id) {
    return this.http.get(`${this.apiUrl}public/club/home-content?id=${id}`, this.httpOptions);
  }

  getJackpot(id) {
    return this.http.get(`${this.apiUrl}public/jackpot-play-info/${id}`, this.httpOptions);
  }
  getCurrentDrawUserTicketNumber(player_id:string,club_id:string,jackpot_id:string){
    // return this.http.get(`${this.apiUrl}public/supporter/last-draw-tickets/${player_id}?club_id=${club_id}&jackpot_id=${jackpot_id}`, this.httpOptions);
    return this.http.get(`${this.apiUrl}public/supporter/current-draw-ticket-count?jackpot_id=${jackpot_id}&club_id=${club_id}&supporter_id=${player_id}`,this.httpOptions);
  }

  getBalanceWithClub(club_id) {
    return this.http.get(`${this.apiUrl}public/supporter/balance/${club_id}`, this.httpOptions);
  }

  savePurchaseInfo(data) {
    return this.http.post(`${this.apiUrl}public/lotto-temp-info`, JSON.stringify(data), this.httpOptions);
  }

  getPurchaseInfo(id) {
    return this.http.get(`${this.apiUrl}public/lotto-temp-info/${id}`, this.httpOptions);
  }

  saveDateOfBirth(data) {
    return this.http.post(`${this.apiUrl}public/supporter/save-dob`, JSON.stringify(data), this.httpOptions);
  }

  deletPurchaseInfo(id) {
    return this.http.delete(`${this.apiUrl}public/lotto-temp-info/${id}`, this.httpOptions);
  }

  supporterPurchaseTicket(data) {
    return this.http.post(`${this.apiUrl}public/purchase-ticket`, JSON.stringify(data), this.httpOptions);
  }

  getFavNumbers() {
    return this.http.get(`${this.apiUrl}public/supporter/favourite-numbers`, this.httpOptions);
  }

  getClubBanner(club_id) {
    return this.http.get(`${this.apiUrl}public/club/home-banner/${club_id}`, this.httpOptions);
  }

  calculatePurchasePrice(picked_up_lines, jackpot, entry_data, special_discount_obj) {
    let total_amount = 0;
    let dis_amount = 0;
    let completed_line = picked_up_lines.filter(line => { return line.picked == true });
    total_amount += jackpot.per_line_price * completed_line.length * entry_data.draw;
    let price_text = `Select 1 line for €${jackpot.per_line_price.toFixed(2)}`;
    if (completed_line.length > 0) {
      let dis_info = jackpot.discounts.find(obj => obj.no_of_tickets == 3);
      if (dis_info) {
        price_text = `Select 3 lines for €${dis_info.amount.toFixed(2)}`;
      }
    }
    if (total_amount > 0 && completed_line.length >= 3) {
      let info = jackpot.discounts.find(obj => obj.no_of_tickets == 6);
      price_text = `Select 6 lines for €${info.amount.toFixed(2)}`;
      let dis_info = jackpot.discounts.find(obj => obj.no_of_tickets == 3);
      if (dis_info) {
        dis_amount = ((jackpot.per_line_price * 3) - dis_info.amount) * entry_data.draw;
      }
    }
    if (total_amount > 0 && completed_line.length >= 6) {
      price_text = '';
      let dis_info = jackpot.discounts.find(obj => obj.no_of_tickets == 6);
      if (dis_info) {
        dis_amount = ((jackpot.per_line_price * 6) - dis_info.amount) * entry_data.draw;
      }
    }
    if (total_amount > 0 && completed_line.length > 6) {
      let sixth_discount = 0;
      let third_discount = 0;
      let sixth_dis_info = jackpot.discounts.find(obj => obj.no_of_tickets == 6);
      let third_dis_info = jackpot.discounts.find(obj => obj.no_of_tickets == 3);
      let total_line = completed_line.length;
      let sixth_multiplier = parseInt((total_line / 6).toString());
      if (sixth_multiplier > 0) {
        sixth_discount = (((jackpot.per_line_price * 6) - sixth_dis_info.amount) * sixth_multiplier) * entry_data.draw;
      }
      let remainder = total_line - (sixth_multiplier * 6);
      let third_multiplier = (remainder / 3);
      if (third_multiplier >= 1) {
        third_discount = ((jackpot.per_line_price * 3) - third_dis_info.amount) * entry_data.draw;
      }
      dis_amount = sixth_discount + third_discount;
    }
    if (special_discount_obj.applied && completed_line.length >= special_discount_obj.no_of_line && entry_data.draw >= special_discount_obj.no_of_week) {
      let regular_amount = (special_discount_obj.no_of_line * jackpot.per_line_price) * special_discount_obj.no_of_week;
      dis_amount = regular_amount - special_discount_obj.discounted_price;
      let multiple_discount = 0
      let week_discount = Math.floor(entry_data.draw / special_discount_obj.no_of_week);
      let line_discount = Math.floor(completed_line.length / special_discount_obj.no_of_line);
      if (week_discount > 1 && line_discount > 1) {
        multiple_discount = Math.min(week_discount, line_discount);
        dis_amount = dis_amount * multiple_discount;
      }
    }
    return { price_text, total_amount, dis_amount };
  }

  validateFavouriteNumber(numbers: string[], maxNumberOfBall: number): boolean {
    let has_invalid_num = numbers.find(nums => nums
      .split(',')
      .map(num => { return parseInt(num) })
      .some(el => el > maxNumberOfBall)
    );
    return has_invalid_num && has_invalid_num.length > 0 ? false : true;
  }

  addFriendRegister(data) {
    return this.http.post(`${this.apiUrl}public/supporter/add-friend`, JSON.stringify(data), this.httpOptions);
  }
  updatePurchaseInfo(data) {
    return this.http.put(`${this.apiUrl}public/lotto-temp-info/${data.id}`,JSON.stringify(data), this.httpOptions);
  }

  updateFavouriteNumber(data) {
    return this.http.put(`${this.apiUrl}public/supporter/favourite-numbers`,JSON.stringify(data), this.httpOptions);
  }


}
